import { Typography as Text } from '@material-ui/core';

import {
  ActivityItem,
  DeltaText,
} from '@spotify/plugin-confidence-activity-react';

import type { Rule } from './types';

export const DescriptionSection = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  if (!oldRule?.description && !newRule?.description) {
    return null;
  }

  return (
    <ActivityItem.Section label="Description">
      {oldRule && newRule && oldRule.description !== newRule.description ? (
        <DeltaText
          oldText={oldRule?.description ?? ''}
          newText={newRule?.description ?? ''}
        />
      ) : (
        <Text variant="body1">
          {newRule?.description ?? oldRule?.description ?? ''}
        </Text>
      )}
    </ActivityItem.Section>
  );
};
